import useSystemDateTheme from "hooks/useSystemDateTheme";
import OrderView from "../..";
import { tabsIds } from "../../orderPage.types";
import AdditionalAttachmentsTab from "../../tabs/AdditionalAttachmentsTab";
import { OrderInfoTab } from "../../tabs/OrderInfoTab";
import { useTranslation } from "react-i18next";
import CourseMinutesTab from "../../tabs/CourseMinutesTab";
import SpeechesTab from "../../tabs/SpeechesTab";
import { useRef } from "react";
import { AdminTapActionsRef } from "../CourseOrderAdminView";
import Actions from "../CourseOrderResearchCenterManagerView/Actions";


const ScientificPublishingUnitOrderView = () => {
    const submitRef = useRef<AdminTapActionsRef>(null);
    const { t } = useTranslation("Orders");
    const { toSystemThemeDateFormat } = useSystemDateTheme();
 

    return (
        <OrderView
            breadcrumbs={({ serialNumber, orderId }) => [
                {
                    localizationKey: "allOrders",
                    path: "/home/orders",
                    menuItemId: "allOrders",
                },
                {
                    localizationKey: "order-number",
                    path: `/home/orders/${orderId}`,
                    localizationParameters: { orderNumber: serialNumber },
                },
            ]}
            defaultTabId="info"
            leftSection={({ selectedTabId, openedTask }) => {
                return <>
                    
                    <Actions openTask={openedTask} selectedTabId={selectedTabId} submitRef={submitRef} />
                </> 
            }}
            tapsToView={({ courseData, courseOrderData, openedTask, activePage, setActivePage, userType,setTriggerOrderUpdate }) => {
                return [
                    {
                        id: tabsIds.info,
                        title: t("info"),
                        content: (
                            <OrderInfoTab
                                setActivePage={setActivePage}
                                activePage={activePage}
                                activeSectionsIds={["workflowNote","applicantInfoWithDetails","CenterManagerSelect","procedures"]}
                                userType={userType}
                                courseOrder={courseOrderData}
                                course={courseData}
                                openedTask={openedTask}
                                submitRef={submitRef}
                                setTriggerOrderUpdate={setTriggerOrderUpdate}
                            />
                        ),
                    },
                    {
                        id: tabsIds.minutesOfMeeting,
                        title: t("minutesOfMeeting"),
                        content: <CourseMinutesTab courseOrderId={courseOrderData?.id ?? 0} submitRef={submitRef} />,
                    },
                    {
                        id: tabsIds.letters,
                        title: t("letters"),
                        content: <SpeechesTab submitRef={submitRef} courseOrderId={courseOrderData?.id ?? 0} />,
                    },

                    {
                        id: tabsIds.attachments,
                        title: t("attachments"),
                        content: <AdditionalAttachmentsTab submitRef={submitRef} courseOrderId={courseOrderData?.id ?? 0} />,
                    },
                ];
            }}
            userType="ScientificPublishingUnit"
            headersToView={({ courseOrderData }) =>
                !courseOrderData
                    ? []
                    : [
                        {
                            title: t("orderNumber"),
                            value: courseOrderData?.serialNumber ?? "",
                        },
                        {
                            title: t("applicationDate"),
                            value: toSystemThemeDateFormat(courseOrderData?.submissionDate), //TODO": return id
                        },
                        courseOrderData?.centreManagement?   {
                                title: t("researchCenter"),
                                value: `${courseOrderData?.centreManagement?.displayName ?? ""}`,
                            }:
                            {
                                title: t("OrderType"),
                                value: `${courseOrderData?.publishingOrderType?.publishingOrderTypeDetail?.displayName ?? ""}`,
                            },

                        {
                            title: t("subspecialty"),
                            value: courseOrderData.scientificSpecializationValue  && courseOrderData.scientificSpecializationValue!=="" ?
                                `${courseOrderData.scientificSpecialization.scientificSpecializationDetail.displayName} (${courseOrderData.scientificSpecializationValue})`
                                : `${courseOrderData.scientificSpecialization.scientificSpecializationDetail.displayName}`,
                        },
                        {
                            title: t("languageOfScientificPublishing"),
                            value: courseOrderData.languageOfScientific?.languageOfScientificDetail?.displayName,
                        },

                        {
                            title: t("typeOfScientificPublishing"),
                            value: courseOrderData.typeOfScientific?.typeOfScientificDetail?.displayName,
                        },
                        {
                            title: t("scientificClassification"),
                            value: courseOrderData.scientificClassification.scientificClassificationDetail.displayName,
                        }

                    ]
            }
        />
    );
};

export default ScientificPublishingUnitOrderView;
